<template>
  <div>
    <modal
      :show.sync="TopicPreview"
      scrollable
      header-classes="bg-primary p-2 flex items-center"
      hide-footer
      size="lg"
      bodyClasses=""
      @close="close"
    >
      <h6 slot="header" class="modal-title text-white pl-4 font-semibold">
        Topic Preview
      </h6>
      <!--
        Previous inline preview logic (replaced by TopicMediaPreview):
        <div v-if="topic_preview.docType == 'video'">
          <video width="100%" height="100%" controls autoplay controlsList="nodownload">
            <source :src="videoUrl" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div v-else-if="topic_preview.docType == 'pdf'">
          <iframe
            class="screenht450 w-full -mt-4"
            :src="pdfUrl"
            frameborder="0"
            height="500"
            width="100%"
          ></iframe>
        </div>
      -->
      <TopicMediaPreview
        v-if="hasTopicMedia"
        :key="`${topic_preview.docPath}-${topic_preview.docType}`"
        :doc-path="topic_preview.docPath"
        :doc-type="topic_preview.docType"
        :image-url="imageBaseUrl"
        :iframe-height="500"
      />
      <template slot="footer">
        <div class="hidden">helo</div>
      </template>
    </modal>
  </div>
</template>

<script>
import TopicMediaPreview from "@/components/TopicMediaPreview.vue";
import { isTopicPreviewable } from "@/utils/mediaUrl";

export default {
  components: {
    TopicMediaPreview,
  },
  props: {
    TopicPreview: Boolean,
    playData: Function,
    topic_preview: Object,
  },
  computed: {
    imageBaseUrl() {
      return (this.$imageURL || process.env.VUE_APP_IMAGE_URL || "").trim();
    },
    hasTopicMedia() {
      return isTopicPreviewable(
        this.topic_preview?.docPath,
        this.topic_preview?.docType
      );
    },
    // Previous computed preview URLs (replaced by TopicMediaPreview):
    // videoUrl() {
    //   return buildMediaUrl(this.topic_preview?.docPath, this.$imageURL);
    // },
    // pdfUrl() {
    //   return buildPdfPreviewUrl(this.topic_preview?.docPath, this.$imageURL);
    // },
  },
  methods: {
    close() {
      this.$emit("close-topicPreview");
    },
  },
};
</script>
